module.exports = __webpack_public_path__ + "img/cup2.8ceca625.png";